// extracted by mini-css-extract-plugin
module.exports = {"benefit":"benefitBlock-module--benefit--1C6WW"};